import { Inject, Injectable, InjectionToken, Optional, SkipSelf } from '@angular/core';

export const PROTECTED_CONTROLS_CONTEXT = new InjectionToken('PROTECTED_CONTROLS_CONTEXT');

@Injectable()
export class ProtectedControlsContext {
  public path: string[] = [];

  constructor(
    @Inject(PROTECTED_CONTROLS_CONTEXT) public contextCrumb: string | string[],
    @Optional()
    @SkipSelf()
    private parent?: ProtectedControlsContext,
  ) {
    const contextCrumbArray = Array.isArray(contextCrumb) ? contextCrumb : [contextCrumb];

    this.path = parent ? [...parent.path, ...contextCrumbArray] : contextCrumbArray;
  }

  public toString(): string {
    return this.path.join('.');
  }

  public set crumb(contextCrumb: string | string[]) {
    const contextCrumbArray = Array.isArray(contextCrumb) ? contextCrumb : [contextCrumb];

    this.path = this.parent ? [...this.parent.path, ...contextCrumbArray] : contextCrumbArray;
  }
}
